export const generateCanonicalLink = () => {
  const { hostname, pathname } = useRequestURL()

  if (pathname === '/') {
    return {
      rel: 'canonical',
      href: `https://${hostname}`,
    }
  }

  const url = `https://${hostname}${pathname}`

  return {
    rel: 'canonical',
    href: url.endsWith('/') ? `${url}` : `${url}/`,
  }
}
